// Benepack OMS · 汇总金额 decimal-safe 工具 (列表汇总金额卡 / 工作台金额 KPI 共用)
//
// 动机: 金额是 numeric(18,4) decimal 串 (避免浮点精度损失 · 全 views.ts *ListItem 金额字段)。
//   前端求和【绝不裸 float 累加】(0.1 + 0.2 → 0.30000000000000004 漂移) → 各串先 ×10000 round
//   成整数 (单位 = 1/10000 元) 累加，末了 /10000 得【元】· 再 /10000 (toWan) 得【万元】。整数累加 → 精度不漂。
//
// 范围: CNY 单币种假设 (本租户成立 · 混币种不在本片范围 · 详见 docs/reports/exec_prompt_summary-amounts)。

/**
 * 汇总取数大 size: 一次拉这么多行到前端求和 (配合截断守卫 · total > 拉取行数 时标 "≥")。
 * 网关 List 实测 size=500 全返 (ref-names 切片同值)。未来某类单据量超此值需后端 SUM 聚合端点。
 */
export const SUMMARY_SIZE = 500;

/**
 * decimal-safe 求和: 各 numeric(18,4) 串 ×10000 round 成整数累加 · 返回【元】(number)。
 * 跳过 null/undefined/空串/非数字 (列表某行缺该金额字段不污染合计)。
 */
export function sumAmounts<T>(rows: T[], pick: (r: T) => string | null | undefined): number {
  let scaled = 0; // 整数累加 · 单位 = 1/10000 元 (numeric(18,4) 的最小刻度)
  for (const r of rows) {
    const s = pick(r);
    if (s == null || s === '') continue;
    const f = parseFloat(s);
    if (!Number.isFinite(f)) continue;
    scaled += Math.round(f * 10000);
  }
  return scaled / 10000; // → 元
}

/** 元 → 万元 (number · 供 AntD Statistic value · precision 由调用方控制)。 */
export function toWan(yuan: number): number {
  return yuan / 10000;
}

/** 元 → 万元 字符串 (2 位小数 · 供 tooltip / 非 Statistic 兜底显示)。 */
export function formatWan(yuan: number): string {
  return (yuan / 10000).toFixed(2);
}

/**
 * 精确元值 (2 位小数 + 千分位 · 供 tooltip 显示 "精确金额 X 元")。
 * 手写千分位 (不依赖 Intl locale · 跨环境确定性 · 金额非负无符号位顾虑)。
 */
export function formatYuan(yuan: number): string {
  const [int, frac] = yuan.toFixed(2).split('.');
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${grouped}.${frac}`;
}
